import React, { Component } from "react";

import { withRequest } from "../../../utils/request";
import Modal from "../../general/Modal";
import Create from "./Create";
import Edit from "./Edit";
import Loader from "../../general/Loader";
import { Link } from "react-router-dom";
import { getLink } from "../../../utils/helpers";
import { gruposDeRespuesta } from "../../../utils/categorias";

class Grupos extends Component {
    state = {
        arbol: [],
        grupo: {},
        padre: null,
        colapsados: [],
        showCreate: false,
        showEdit: false,
        loading: true,
    };
    componentDidMount() {
        this.getGrupos();
    }
    getGrupos = async () => {
        // El árbol trae solo las raíces con sus `hijos` anidados y no se pagina.
        const respuesta = await this.props.request("grupos?arbol=1");

        this.setState({
            arbol: gruposDeRespuesta(respuesta),
            loading: false,
        });
    };
    toggleCreateModal = (padre = null) => {
        this.setState({
            showCreate: !this.state.showCreate,
            grupo: {},
            padre: padre,
        });
    };
    toggleEditModal = (grupo) => {
        this.setState({
            showEdit: !this.state.showEdit,
            grupo: grupo,
        });
    };
    toggleColapsado = (id) => {
        this.setState({
            colapsados: this.state.colapsados.includes(id)
                ? this.state.colapsados.filter((actual) => actual !== id)
                : [...this.state.colapsados, id],
        });
    };
    renderFilas = (categorias, nivel = 0) =>
        categorias.reduce((filas, grupo) => {
            const hijos = grupo.hijos || [];
            const colapsado = this.state.colapsados.includes(grupo.id);

            return [
                ...filas,
                <tr className='tr-shadow' key={grupo.id}>
                    <td>
                        {grupo.foto?.url && (
                            <img
                                src={grupo.foto?.url}
                                alt={grupo.nombre}
                                style={{ maxHeight: "64px" }}
                            />
                        )}
                    </td>
                    <td>
                        <span style={{ paddingLeft: `${nivel * 25}px` }}>
                            {nivel > 0 && (
                                    <span className='text-muted m-r-5'>
                                        &#8212;
                                    </span>
                            )}
                            {grupo.nombre}
                            {hijos.length > 0 && (
                                <span className='m-l-10'>
                                    ({hijos.length})
                                </span>
                            )}
                        </span>
                    </td>
                    <td className='text-center'>{grupo.productos}</td>
                    <td className='text-center'>{grupo.items}</td>
                    <td>{grupo.visible_tienda ? "Sí" : "No"}</td>
                    <td>
                        <div className='table-data-feature'>
                            <button
                                className='item'
                                title='Añadir subcategoría'
                                onClick={() => {
                                    this.toggleCreateModal(grupo);
                                }}>
                                <i className='zmdi zmdi-plus' />
                            </button>
                            <button
                                className='item'
                                data-toggle='tooltip'
                                data-placement='top'
                                title='Editar'
                                data-original-title='Edit'
                                onClick={() => {
                                    this.toggleEditModal(grupo);
                                }}>
                                <i className='zmdi zmdi-edit' />
                            </button>
                        </div>
                    </td>
                </tr>,
                ...(colapsado ? [] : this.renderFilas(hijos, nivel + 1)),
            ];
        }, []);
    render() {
        const { arbol, loading, padre } = this.state;
        return (
            <div>
                <div className='page-header'>
                    <Link to={getLink('/productos/')}>&laquo; Volver a productos</Link>
                    <h1 className='page-title row'>
                        <span className='col'>Categorías de Productos</span>
                        <button
                            className='au-btn au-btn-icon au-btn--green au-btn--small'
                            onClick={() => this.toggleCreateModal(null)}>
                            <i className='zmdi zmdi-plus' />
                            Añadir Grupo
                        </button>
                    </h1>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div>
                            {loading && <Loader />}
                            {!arbol.length ? (
                                <div>
                                    {!loading && (
                                        <div>
                                            Todavía no hay grupos creados.
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className='table-data'>
                                    <table className='table table-data2'>
                                        <thead>
                                            <tr>
                                                <th>Image</th>
                                                <th>Nombre</th>
                                                <th className='text-center'>Productos</th>
                                                <th className='text-center'>Items</th>
                                                <th>Visible en tienda</th>
                                                <th />
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.renderFilas(arbol)}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <Modal
                    show={this.state.showCreate}
                    blank={true}
                    toggle={() => this.toggleCreateModal(null)}>
                    <Create
                        toggle={() => this.toggleCreateModal(null)}
                        grupo={this.state.grupo}
                        padre={padre}
                        arbol={arbol}
                        getGrupos={this.getGrupos}
                    />
                </Modal>
                <Modal
                    show={this.state.showEdit}
                    blank={true}
                    toggle={() => this.toggleEditModal({})}>
                    <Edit
                        toggle={() => this.toggleEditModal({})}
                        grupo={this.state.grupo}
                        arbol={arbol}
                        getGrupos={this.getGrupos}
                    />
                </Modal>
            </div>
        );
    }
}

export default withRequest(Grupos);
